export default __webpack_public_path__ + "static/media/kakareko.8fa7f83c.gif";